// extracted by mini-css-extract-plugin
module.exports = {"Space":"Space--1LUpu","Icon":"Icon--PEQZS","Tag":"Tag--3RFPX"};